export default [{
  path: 'index',
  cn: '简介',
  en: 'Home'
}, {
  path: 'introductions',
  cn: '自我介绍',
  en: 'About me'
}, {
  path: 'skills',
  cn: '技能',
  en: 'Skills'
}, {
  path: 'works',
  cn: '工作经历',
  en: 'Works'
}, {
  path: 'projects',
  cn: '项目经历',
  en: 'Projects'
}]
// , {
//   path: 'articles',
//     cn: '个人博客',
//     en: 'Articles'
// }



// WEBPACK FOOTER //
// ./src/router.js